import * as React from 'react'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

import './styles.scss'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'milestone'

/**
 * This is the component description.
 */
const Milestone = ({
  id,
  className:userClassName,
  style,
  company,
  imagePath,
  subtitle,
  achievements,
  desktopSubtitle,
  hasDesktopDivider,
}) => (
  <div
    id={id}
    className={[
      baseClassName,
      componentClassName,
      userClassName,
      hasDesktopDivider && 'has-desktop-divider',
    ]
      .filter((e) => e)
      .join(' ')}
    style={style}
  >
    <img
      src={imagePath}
      alt={company}
    />
    <p className="x-metadata c-x hide-on-desktop">{subtitle}</p>
    <p className="x-metadata c-x hide-on-mobile">{desktopSubtitle}</p>
    {
      achievements?.map((achievement) => (
        <p className="milestone-info">
          <span className="icon x-main c-x">I</span>
          <span>{achievement}</span>
        </p>
      ))
    }
  </div>
)

Milestone.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   * The company name
   */
  company:PropTypes.string,

  /**
   * The company logo
   */
  imagePath:PropTypes.string,

  /**
   * The subtitle
   */
  subtitle:PropTypes.string,

  /**
   * The achievements to display
   */
  achievements:PropTypes.arrayOf(PropTypes.string),

  /**
   * The desktop subtitle
   */
  desktopSubtitle:PropTypes.string,

  /**
   * Whether to include a bottom border
   */
  hasDesktopDivider:PropTypes.bool,
}

Milestone.defaultProps = {
//
}

export default Milestone
